/**
 * Declension - Склонение
 * (4301).decline(['Минута', 'Минуты', 'Минут']) => Минута
 *
 * @param {Number} number
 * @param {Array} titles [titles] <= ['Один ДЕНЬ', 'Два ДНЯ', 'Пять ДНЕЙ']
 * @returns {String}
 */
export default function decline(number, titles) {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
}
